import { useMotionPreference } from 'web-api-hooks';

const useMotionReduce = () =>
  useMotionPreference() === 'reduce' || process.env.JEST_WORKER_ID !== undefined;

export default useMotionReduce;
